import React from 'react';

const Campaign = () => <img src="demo2.png" width="100%" alt="demo" />;

export default Campaign;
